import { A11yModule } from '@angular/cdk/a11y';

import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CONTENT_TYPES, MODES } from '@go-modules/components/library/library-collections-viewer/library-collection-viewer.constants';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { LibraryCollectionViewerComponent } from '@go-modules/components/library/library-collections-viewer/library-collection-viewer.component';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

export interface LibraryDialogData {
	filterType?: CONTENT_TYPES[];
	mode?: string;
	previewable?: boolean;
	collectionManagement?: boolean;
	create?: boolean;
	openToOrg?: number;
	context?: LibraryDialogContext;
}

export interface LibraryDialogContext {
	group?: unknown | null;
	account?: unknown | null;
	org?: unknown | null;
	license?: unknown | null;
	orgSettings?: unknown | null;
}

@Component({
	selector: 'library-dialog',
	imports: [
		TranslateModule,
		GoMaterialModule,
		A11yModule,
		GoDialogContentDirective,
		forwardRef(() => LibraryCollectionViewerComponent)
	],
	templateUrl: './library-dialog.component.html',
	styleUrls: ['./library-dialog.component.scss']
})
export class LibraryDialogComponent implements OnInit {
	public collectionManagement: boolean = true;
	public readonly dialogTitleId = 'library-dialog-title';

	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: LibraryDialogData,
		private translate: TranslateService
	) {
	}

	public ngOnInit () {
		if (this.data.collectionManagement !== undefined) {
			this.collectionManagement = this.data.collectionManagement;
		}
	}

	public selectItem (item) {
		this.dialogRef.close(item);
	}

	public cancel () {
		this.dialogRef.close(null);
	}

	public modalTitleValue () {
		if (this.data.mode && this.data.mode === MODES.SELECT) {
			const typeOrTypes = this.data.filterType.length > 1 ? this.data.filterType.join(' or ') : this.data.filterType[0];
			const assignment = this.translate.instant('library-collections_add-activity');
			return this.translate.instant('library-collection-viewer_select-mode-title', { type: typeOrTypes.replace('activity', assignment) });
		} else {
			return this.translate.instant('common_library');
		}
	}
}
